<lvr-simple-panel>
	@if (!person()) {
		<span title>{{ 'sponsor.menu.contact_person' | transloco }}</span>
	} @else {
		<span title>{{ person()?.name }}{{ person()?.firstName ? ', ' + person()?.firstName : '' }}</span>
	}
	<div content>
		@if (!person()) {
			{{ 'sponsor.persons.no_persons' | transloco: { name: sponsorName() } }}
		} @else {
			<table>
				<tr>
					<th scope="col">{{ 'base.field.gender' | transloco }}</th>
					<th scope="col">{{ 'base.field.contact_point.title' | transloco }}</th>
				</tr>
				<tr>
					<td>
						{{ person()?.gender?.salutation ?? '-' }}
					</td>
					<td>
						<ul>
							@for (contactPoint of person()?.contactPoints; track contactPoint.id) {
								<li>
									{{ contactPoint.contactValue }}<br />
									{{ contactPoint.remark }}
								</li>
							}
						</ul>
					</td>
				</tr>
			</table>
		}
	</div>
</lvr-simple-panel>
